import React from 'react';

export default () => <div style={{ height: '24px' }} />;
